export default __webpack_public_path__ + "assets/models/462c7f17161f1c62ce48fd23908c28fe.glb";